import { Component } from '@angular/core';
import { FieldType } from '@kre-form/core';

// <ion-icon name="eye-off-outline"></ion-icon>
@Component({
  selector: 'kreform-field-ion-password',
  template: `
    <ng-container *ngIf="!!editor; else other">
      <ion-input
        [type]="showPwd ? 'text' : 'password'"
        [formControl]="formControl"
        [ionKreFormAttributes]="field"
      >
      </ion-input>
      <ion-icon
        [name]="showPwd ? 'eye-outline' : 'eye-off-outline'"
        (click)="showPwd = !showPwd"
      ></ion-icon>
    </ng-container>
    <ng-template #other>
      <div class="fieldtext">{{ text }}</div>
    </ng-template>
  `,
})
export class KreFormFieldIonPassword extends FieldType {
  showPwd = false;
  constructor() {
    super();
  }
}
